"use client"

import React, { useState } from "react"
import ContentDisplay from "../ContentDisplay/ContentDisplay"
import styles from "./Services.module.css"

export default function Services() {
    const services = [
      {
        id: "research",
        icon: "/icons/research.svg",
        label: "Research",
        content: {
          title: "Research First",
          description:
            "We leverage in-depth research and data-driven insights to identify real-world challenges, ensuring our solutions are impactful and aligned with user needs.",
          image: "/images/research.png",
        },
      },
      {
        id: "uxDesign",
        icon: "/icons/ux-design.svg",
        label: "UX Design",
        content: {
          title: "User-Centric Design",
          description:
            "Our UX design process focuses on creating intuitive and accessible interfaces that prioritize user needs and enhance overall safety experiences.",
          image: "/images/design.png",
        },
      },
      {
        id: "development",
        icon: "/icons/development.svg",
        label: "Development",
        content: {
          title: "Cutting-Edge Development",
          description:
            "We employ the latest technologies and best practices in software development to build robust, scalable, and secure IoT safety solutions.",
          image: "/images/dev.png",
        },
      },
      {
        id: "hardware",
        icon: "/icons/hardware.svg",
        label: "Hardware",
        content: {
          title: "Innovative Hardware Solutions",
          description:
            "Our hardware team designs and integrates cutting-edge sensors and devices to create comprehensive IoT safety ecosystems.",
          image: "/images/hardware.png",
        },
      },
      {
        id: "support",
        icon: "/icons/support.svg",
        label: "Support",
        content: {
          title: "Ongoing Support",
          description:
            "We provide continuous support and maintenance to ensure our IoT safety solutions remain effective and up-to-date in an ever-evolving technological landscape.",
          image: "/images/support.png",
        },
      }
    ];

    const [activeService, setActiveService] = useState(services[0].id);
    const activeContent = services.find((service) => service.id === activeService).content;

    return (
    <section className={styles.service} id="work">
      <div className={styles.container}>
        <header className={styles.header}>
          <h1 className={styles.title}>WHAT WE DO.</h1>
          <p className={styles.subtitle}>
            We design and develop innovative IoT-driven safety solutions that enhance everyday living. From insights and
            design to advanced software development, we bridge technology and safety to deliver seamless, user-friendly
            experiences.
          </p>
        </header>
        <div className={styles.servicesContainer}>
          <ContentDisplay
            content={activeContent}
            services={services}
            activeService={activeService}
            setActiveService={setActiveService}
          />
        </div>
      </div>
      </section>
    );
}